import { render } from "./Header.vue?vue&type=template&id=5ebd6ca4"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=5ebd6ca4&lang=css"

import exportComponent from "/Users/martinflores/Documents/kitsuu-landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__